import Vue from 'vue';
import Router from 'vue-router';
import Landing from './views/Landing.vue';
import ComoFunciona from './views/ComoFunciona.vue';
import Precio from './views/Precio.vue';
import ComprarKit from './views/ComprarKit.vue';
import Orden from './views/Orden.vue';
import EresCandidato from './views/EresCandidato.vue';
import SiEresCandidato from './views/SiEresCandidato.vue';
import NoEresCandidato from './views/NoEresCandidato.vue';
import SobreNosotros from './views/About.vue';
import PaymentCanceled from './views/PaymentCanceled.vue';
import PaymentSucess from './views/PaymentSucess.vue';
import Faqs from './views/Faqs.vue';
import TerminosYCondiciones from './views/TerminosYCondiciones.vue';
import Politica from './views/Politica.vue';
import Productos from './views/Productos.vue';
import KitBlanqueamiento from './views/KitBlanqueamiento.vue';
import CompraTratamiento from './views/CompraTratamiento.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'landing',
      component: Landing,
    },
    {
      path: '/como-funciona',
      name: 'como-funciona',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: ComoFunciona,
    },
    {
      path: '/precio',
      name: 'precio',
      component: Precio,
    },
    {
      path: '/comprar-kit',
      name: 'comprar-kit',
      component: ComprarKit,
    },
    {
      path: '/orden-en-camino',
      name: 'orden-en-camino',
      component: Orden,
    },
    {
      path: '/eres-candidato',
      name: 'eres-candidato',
      component: EresCandidato,
    },
    {
      path: '/si-eres-candidato',
      name: 'si-eres-candidato',
      component: SiEresCandidato,
    },
    {
      path: '/no-eres-candidato',
      name: 'no-eres-candidato',
      component: NoEresCandidato,
    },
    {
      path: '/payment-sucess',
      name: 'payment-success',
      component: PaymentSucess,
    },
    {
      path: '/payment-canceled',
      name: 'payment-canceled',
      component: PaymentCanceled,
    },
    {
      path: '/sobre-nosotros',
      name: 'sobre-nosotros',
      component: SobreNosotros,
    },
    {
      path: '/faqs',
      name: 'faqs',
      component: Faqs,
    },
    {
      path: '/terminos-y-condiciones',
      name: 'terminos-y-condiciones',
      component: TerminosYCondiciones,
    },
    {
      path: '/politica',
      name: 'politica',
      component: Politica,
    },
    {
      path: '/productos',
      name: 'productos',
      component: Productos,
    },
    {
      path: '/kit-blanqueamiento',
      name: 'kit-blanqueamiento',
      component: KitBlanqueamiento,
    },
    {
      path: '/compra-tratamiento',
      name: 'compra-tratamiento',
      component: CompraTratamiento,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
